<template>
  <v-form @submit.prevent ref="form">
    <v-alert type="success" :value="registerOk" transition="slide-x-transition">
        Boli ste úspešne registrovaný, pokračujte prihlásením
    </v-alert>
    <v-container>
      <v-row justify="center">
        <h2>
          <span class="hoverable" :class="{'grey--text': !loginForm}" @click="loginForm = true">Prihlásenie</span>
          <span class="pa-1">/</span>
          <span class="hoverable" :class="{'grey--text': loginForm}" @click="loginForm = false">Registrácia</span>
        </h2>
      </v-row>
    </v-container>
    <login :refForm="refForm" v-if="loginForm" />
    <registration :refForm="refForm" @registerCompleted="registerCompleted" v-else />
  </v-form>
</template>

<script>
import Registration from "@/components/authentication/Registration";
import Login from "@/components/authentication/Login";
export default {
  name: "LoginForm",
  components: {Login, Registration},
  data: () => ({
    loginForm: true,
    refForm: null,
    registerOk: false,
  }),
  methods: {
    registerCompleted(){
      this.loginForm = true;
      this.$vuetify.goTo(0, {
          easing: "easeInOutCubic",
          duration: 800
      });
      this.registerOk = true
      setTimeout(() => {
        this.registerOk = false;
      }, 2500)
      
    }
  },
  mounted(){
    this.refForm = this.$refs.form;
  }
}
</script>

<style scoped>
.hoverable {
  cursor: pointer;
}
</style>